class DateFormat {
  _patterns: Array<any>
  _formatter: any
  constructor(pattern: any) {
    this.init(pattern)
    this._formatter = {
      y: (date: any, pattern: any) => {
        // Year
        let year = String(date.getFullYear())
        if (pattern.length <= 2) {
          year = year.substring(2, 4)
        } else {
          year = this._zeroPadding(year, pattern.length)
        }
        return year
      },
      M: (date: any, pattern: any) => {
        // Month in year
        return this._zeroPadding(String(date.getMonth() + 1), pattern.length)
      },
      d: (date: any, pattern: any) => {
        // Day in month
        return this._zeroPadding(String(date.getDate()), pattern.length)
      },
      H: (date: any, pattern: any) => {
        // Hour in day (0-23)
        return this._zeroPadding(String(date.getHours()), pattern.length)
      },
      m: (date: any, pattern: any) => {
        // Minute in hour
        return this._zeroPadding(String(date.getMinutes()), pattern.length)
      },
      s: (date: any, pattern: any) => {
        // Second in minute
        return this._zeroPadding(String(date.getSeconds()), pattern.length)
      },
      S: (date: any, pattern: any) => {
        // Millisecond
        return this._zeroPadding(String(date.getMilliseconds()), pattern.length)
      },
      "'": (date: any, pattern: any) => {
        // escape
        if (pattern === "''") {
          return "'"
        } else {
          return pattern.replace(/'/g, "")
        }
      },
    }
  }

  init = (pattern: any) => {
    this._patterns = []
    for (let i = 0; i < pattern.length; i++) {
      const ch = pattern.charAt(i)
      if (this._patterns.length === 0) {
        this._patterns[0] = ch
      } else {
        const index = this._patterns.length - 1
        if (this._patterns[index].charAt(0) === "'") {
          if (
            this._patterns[index].length === 1 ||
            this._patterns[index].charAt(this._patterns[index].length - 1) !==
              "'"
          ) {
            this._patterns[index] += ch
          } else {
            this._patterns[index + 1] = ch
          }
        } else if (this._patterns[index].charAt(0) === ch) {
          this._patterns[index] += ch
        } else {
          this._patterns[index + 1] = ch
        }
      }
    }
  }

  format = (date: string) => {
    let result: Array<any> = []
    for (let i = 0; i < this._patterns.length; i++) {
      result[i] = this._formatWord(date, this._patterns[i])
    }
    return result.join("")
  }

  _formatWord = (date: string, pattern: any) => {
    const formatter = this._formatter[pattern.charAt(0)]
    if (formatter) {
      return formatter.apply(this, [date, pattern])
    } else {
      return pattern
    }
  }

  _zeroPadding = (str: string, length: number) => {
    if (str.length >= length) {
      return str
    }
    return new Array(length - str.length + 1).join("0") + str
  }
}

const Convert = {
  date: (data: any, format: any) => {
    let result
    if (!data) {
      return ""
    }
    try {
      // YYYYMMDD
      if (typeof data === "number" && data.toString().length === 8) {
        data = data.toString()
        data =
          data.slice(0, 4) + "/" + data.slice(4, 6) + "/" + data.slice(6, 8)
        // YYYYMM
      } else if (typeof data === "number" && data.toString().length === 6) {
        data = data.toString()
        data = data.slice(0, 4) + "/" + data.slice(4, 6)
      } else if (typeof data === "string" && data.length === 14) {
        data = data.toString()
        data =
          data.slice(0, 4) +
          "/" +
          data.slice(4, 6) +
          "/" +
          data.slice(6, 8) +
          " " +
          data.slice(8, 10) +
          ":" +
          data.slice(10, 12) +
          ":" +
          data.slice(12, 14)
      }
      const _data: any = new Date(data)
      if (isNaN(_data.getTime())) {
        return data.toString()
      }
      const fmt: any = new DateFormat(format)
      result = fmt.format(_data)
    } catch (e) {}
    return result
  },
}
export default Convert
